import adminDepartmentModel from '../../models/admin-department';
import adminDepartmentsCommitTypes from './commit-types';
import ReducerUtilities from '../../../shared/store/reducer-utilities';

const INITIAL_ADMIN_DEPARTMENT_STATE = {
  isAddingDepartment: false,
  list: null,
  isLoading: [],
  validationErrors: null,
};

function departmentReducers(state = INITIAL_ADMIN_DEPARTMENT_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case adminDepartmentsCommitTypes.PUSH_ADMIN_DEPARTMENT:
      return {
        ...state,
        list: !state.list
          ? [adminDepartmentModel(action.department)]
          : [adminDepartmentModel(action.department), ...state.list],
      };
    case adminDepartmentsCommitTypes.PUSH_ADMIN_DEPARTMENTS:
      return {
        ...state,
        list: [...action.list.map(item => adminDepartmentModel(item))],
      };
    case adminDepartmentsCommitTypes.PUSH_ADMIN_DEPARTMENT_VALIDATION_ERRORS:
      // Always replace these as this key is populated from an API call, and we don't want
      //   to report errors from a previous API call
      return {
        ...state,
        validationErrors: [...action.validationErrors],
      };
    case adminDepartmentsCommitTypes.RESET_ADMIN_DEPARTMENT_STATE:
      return { ...INITIAL_ADMIN_DEPARTMENT_STATE };
    case adminDepartmentsCommitTypes.SET_IS_ADDING_ADMIN_DEPARTMENT:
      return {
        ...state,
        isAddingDepartment: action.isAddingDepartment,
      };
    case adminDepartmentsCommitTypes.SET_ADMIN_DEPARTMENTS_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };
    default:
      return state;
  }
}

export default departmentReducers;
